export function time() {
  return new Date().getTime()
}
